/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { RepresentantSelectorGridDto } from './RepresentantSelectorGridDto';
import {
    RepresentantSelectorGridDtoFromJSON,
    RepresentantSelectorGridDtoFromJSONTyped,
    RepresentantSelectorGridDtoToJSON,
} from './RepresentantSelectorGridDto';

/**
 * 
 * @export
 * @interface RepresentantSelectorGridDtoPaginatedResults
 */
export interface RepresentantSelectorGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof RepresentantSelectorGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<RepresentantSelectorGridDto>}
     * @memberof RepresentantSelectorGridDtoPaginatedResults
     */
    results?: Array<RepresentantSelectorGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof RepresentantSelectorGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the RepresentantSelectorGridDtoPaginatedResults interface.
 */
export function instanceOfRepresentantSelectorGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RepresentantSelectorGridDtoPaginatedResultsFromJSON(json: any): RepresentantSelectorGridDtoPaginatedResults {
    return RepresentantSelectorGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function RepresentantSelectorGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepresentantSelectorGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(RepresentantSelectorGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function RepresentantSelectorGridDtoPaginatedResultsToJSON(value?: RepresentantSelectorGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(RepresentantSelectorGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

